<template>
  <base-button
    class="ps-flex ps-items-center ps-justify-center ps-px-4 ps-py-2 ps-border ps-border-transparent ps-text-base ps-leading-6 ps-font-medium ps-rounded-md ps-text-white  ps-bg-gray-600 hover:ps-bg-gray-500 focus:ps-outline-none focus:ps-border-indigo-700 focus:ps-shadow-outline ps-transition ps-duration-150 ps-ease-in-out"
    @button-click="$emit('button-click')"
    :disabled="disabled"
  >
    <span class="ps-text-white">
      <slot />
    </span>
  </base-button>
</template>

<script>
import BaseButton from './BaseButton'

export default {
  name: 'ButtonPrimary',
  props: {
    disabled: Boolean
  },
  components: {
    BaseButton
  }
}
</script>
